import React from 'react'
import AvisoSimpleFiles from './AvisoSimpleFiles'
import AvisoIntegralFiles from './AvisoIntegralFiles'

export default function AvisoContainer() {
    return (
        <div>
            <hr />
            <div className='container pb-2'>
                <ul className="nav nav-pills justify-center" id="pills-tab" role="tablist">
                    <li className="nav-item navHead" role="presentation">
                        <button className="nav-link form-control active" id="pills-avissimple-tab" data-bs-toggle="pill" data-bs-target="#pills-avissimple" type="button" role="tab" aria-controls="pills-avissimple" aria-selected="true">Aviso de privacidad simple</button>
                    </li>
                    <li className="nav-item navHead" role="presentation">
                        <button className="nav-link form-control" id="pills-avisintegral-tab" data-bs-toggle="pill" data-bs-target="#pills-avisintegral" type="button" role="tab" aria-controls="pills-avisintegral" aria-selected="false">Aviso de privacidad integral</button>
                    </li>
                </ul>
                <div className="tab-content" id="pills-tabContent">
                    <div className="tab-pane fade show active" id="pills-avissimple" role="tabpanel" aria-labelledby="pills-avissimple-tab">
                        <AvisoSimpleFiles />
                    </div>
                    <div className="tab-pane fade" id="pills-avisintegral" role="tabpanel" aria-labelledby="pills-avisintegral-tab">
                        <AvisoIntegralFiles />
                    </div>
                </div>
            </div>
        </div>
    )
}
